var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriceTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 136.1 104.4",
    style: {
      enableBackground: "new 0 0 136.1 104.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.8,0.3c5.4,0.3,10.5,1.9,15.7,3c26.4,5.5,52.7,11.3,79.1,16.8c7.3,1.5,12.6,5.2,14.8,12.4 c2.1,7.2,0.1,13.4-5.3,18.8c-9.9,9.9-19.7,20.1-29.5,30.2c-2.1,2.2-4.6,3.7-7.9,4.4C98.8,92,104.9,98,110.9,104 c-0.1,0.2-0.2,0.3-0.3,0.5c-9.8-2.1-19.6-4.1-29.4-6.2C59,93.5,36.9,88.7,14.8,84C7.9,82.6,3.1,78.8,1,72c-2.2-6.8-0.6-12.9,4.3-18 c10.3-10.6,20.7-21.2,31-31.8c2-2,4.4-3.1,7.4-3.9C38.2,12.9,33,7.7,27.8,2.5C27.1,1.8,26.2,1.3,25.8,0.3L25.8,0.3z M94.1,73.8 c0-3.5-1.3-6.4-3.7-8.9C76.3,50.8,62.1,36.7,48,22.6c-1.4-1.4-2.1-1.1-3.2,0.2c-4.1,4.7-3.7,11.7,1,16.4c9.7,9.7,19.4,19.3,29.1,29 c4.5,4.5,9,8.9,13.5,13.5c1.2,1.3,2,1.2,3-0.1C93.1,79.3,94.2,76.7,94.1,73.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.9,0.3c-0.1,0-0.2-0.1-0.2-0.1c0,0,0-0.1,0-0.2C25.7,0.1,25.8,0.2,25.9,0.3C25.8,0.3,25.9,0.3,25.9,0.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceTwo);
export default __webpack_public_path__ + "static/media/price-two.49f32b47f5e22aa7d644b4bd16bce2fb.svg";
export { ForwardRef as ReactComponent };